<div class="profile-user">
  <svg class="skeleton-animation-white" style="border-radius: 50%"></svg>
  <h3 class="skeleton-animation-white" style="height: 12px; width: 30%"></h3>
</div>
